/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-return-assign */

import React from 'react';
import { Button, Modal } from 'rsuite';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import api from '~/services/api';

function ModalDeletarCandidato({ setModalExcluir, modalExcluir, deleteCandidato, setAtualizarLista }) {
  async function deletarCandidato() {
    try {
      await api.delete(`/candidato-entrevista/delete/${deleteCandidato.id}`);
      toast.success('Candidato excluída com sucesso!');
      setAtualizarLista((prev) => !prev);
      setModalExcluir(false);
    } catch (error) {
      toast.error('Erro ao excluir a candidato.');
    }
  }

  return (
    <Modal open={modalExcluir} onClose={() => setModalExcluir(false)} size="xs">
      <Modal.Header>Excluir Candidato</Modal.Header>
      <Modal.Body>
        <p>Deseja realmente excluir este candidato ?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setModalExcluir(false)} appearance="subtle">
          Cancelar
        </Button>
        <Button appearance="primary" type="button" onClick={() => {deletarCandidato()}}>
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

// Definição correta do PropTypes
ModalDeletarCandidato.propTypes = {
  setModalExcluir: PropTypes.func.isRequired,
  setAtualizarLista: PropTypes.func.isRequired,
  modalExcluir: PropTypes.bool.isRequired,
  deleteCandidato: PropTypes.object.isRequired, // Ajustado o nome correto
};

export default ModalDeletarCandidato
